import { Button, Dialog, Flex, Text } from '@leverege/ui-elements'
import moment from 'moment'
import React, { useMemo, useRef, useState } from 'react'
import ResourceImageValueComponent from '../components/ResourceImageValueComponent'
import getReadableLabel from '../helpers/getReadableLabel'

export default function useAlertsTable( props ) {
  const { result, delegate } = props

  const idCache = useRef( {} )

  const data = useMemo(
    () => result?.items?.map( item => ( {
      eventId : item?.data?.eventId,
      state : item?.ackId,
      type : item?.data?.cause ?? item?.data?.subtype,
      image : item?.data?.resource?.path,
      category : item?.type,
      location : item?.data?.location,
      scanTime : item?.receivedTime,
      original : item
    } ) ) ?? [],

    [ result ],
  )

  const columns = useMemo( () => {
    return [
      {
        id : 'id',
        Header : 'Event ID',
        accessor : ( row ) => {
          if ( row.eventId ) {
            return row.eventId
          }
          const { type, original : { id } } = row

          if ( idCache.current[id] ) {
            return idCache.current[id]
          }

          let prefix = type.charAt( 0 ).toUpperCase()
          for ( let i = 1; i < type.length; i++ ) {
            const char = type.charAt( i )
            if ( char === char.toUpperCase() ) {
              prefix += char
            }
          }
          let suffix = ''

          for ( let i = 0; i < 5; i++ ) {
            const char = id.charAt( i )
            suffix += char.toUpperCase()
          }

          idCache.current[id] = `${prefix}-${suffix}`

          return idCache.current[id]
        },
        Cell : ( { value } ) => <Text>{value ?? '-'}</Text>,
      },
      {
        id : 'state',
        Header : 'State',
        accessor : 'state',
        Cell : ( { value } ) => <Text>{value ? 'Acknowledged' : 'Active'}</Text>,
      },
      {
        id : 'type',
        Header : 'Type',
        accessor : 'type',
        Cell : ( { value } ) => <Text>{getReadableLabel( value ) ?? '-'}</Text>,
      },
      {
        id : 'image',
        Header : 'Image',
        accessor : 'image',
        Cell : ( { value } ) => <ResourceImageRenderer value={value} delegate={delegate} />,
      },
      {
        id : 'category',
        Header : 'Category',
        accessor : 'category',
        Cell : ( { value } ) => <CategoryValueRenderer value={value} />,
      },
      {
        id : 'location',
        Header : 'Location',
        accessor : 'location',
        Cell : ( { value } ) => <Text>{value ?? '-'}</Text>,
      },
      {
        id : 'scanTime',
        Header : 'Scan Time',
        accessor : 'scanTime',
        Cell : ( { value } ) => (
          <Text>{value ? moment( value ).format( 'M/D HH:mm a' ) : '-'}</Text>
        ),
      },
    ]
  }, [ delegate ] )

  return {
    data,
    columns,
  }
}

function CategoryValueRenderer( { value } ) {
  const variant = value === 'safety' ? 'pillSafety' : 'pillProduct'
  return (
    <Flex>
      <Text variant={variant}>{getReadableLabel( value ) || '-'}</Text>
    </Flex>
  )
}

function ResourceImageRenderer( props ) {
  const { value, delegate } = props
  const [ showDialog, setShowDialog ] = useState( false )

  return (
    <>
      {value ? (
        <Button
          variant="imageButton"
          onClick={() => setShowDialog( true )}
          icon="fa-regular fa-image"/>
      ) : (
        '-'
      )}
      <Dialog
        bodyVariant="dialogBody"
        title={(
          <Flex variant="rowSpaceBetween">
            <Text variant="dialogTitle">
              View Image
            </Text>
            <Button
              onClick={() => setShowDialog( false )}
              variant="closeDialog"/>
          </Flex>
        )}
        show={showDialog}
        onClose={() => setShowDialog( false )}>
        <Flex align="center" justify="center">
          <ResourceImageValueComponent
            value={value}
            path={value}
            valueStyle={{ height : 635 }}
            clientProps={{ delegate }}/>
        </Flex>
      </Dialog>
    </>
  )
}
